import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './assets/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import "react-datepicker/dist/react-datepicker.css";
import './assets/css/style.css'
import './assets/css/responsive.css'
import './assets/css/edit.css'
import Home from './pages/home/home';
import TagList from "../src/pages/home/list-show-all";
import Login from './admin/login';
import AdminList from './admin/admin-list';
import UserList from './admin/user-list';
import VideoList from './admin/video-list';
import VideoRequest from './admin/video-requests';
import TagDirectory from './admin/tag-directory';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { performLogout } from './utils/logout';
import SharePage from "../src/pages/home/ListVideo"
import ApproverList from './admin/approver-list';
import SuperAdminList from './admin/superAdmin-list';
import ResetPassword from './admin/resetPassword';
import SetPassword from './admin/SetPassword';
import VerifyEmail from './admin/VerifyEmail';
import Reprocess from './admin/reprocess';
import MyRequests from './pages/user/my-requests';

function App() {
  const { isAuthenticated } = useSelector((state) => state.authentication)
  const { userData } = useSelector((state) => state.masterData)
  const dispatch = useDispatch();

  // On app load: if Redux says authenticated but the session token is missing or expired, log out.
  useEffect(() => {
    if (!isAuthenticated) return;
    const token = window.localStorage.getItem("sessionToken");
    if (!token) {
      performLogout(dispatch);
      return;
    }
    try {
      // JWTs use base64url (- and _ instead of + and /); atob needs standard base64
      const b64 = token.split(".")[1].replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(atob(b64));
      if (payload.exp && payload.exp * 1000 < Date.now()) {
        performLogout(dispatch);
      }
    } catch (_) {
      performLogout(dispatch);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Router>
      {/* Single app-wide toast host — components call toast.*(); duplicate per-page
          containers were removed (they caused duplicated toasts). */}
      <ToastContainer />
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/tag-search' element={<TagList />}></Route>
        <Route path='/login' element={<Login />}></Route>       
        <Route path='/share/:id' element={<SharePage />}></Route>   
        <Route path='/reset-password' element={<ResetPassword/>} ></Route>
        <Route path='/set-password' element={<SetPassword/>} ></Route>
        <Route path='/verify-email' element={<VerifyEmail/>} ></Route>
        {(isAuthenticated && userData?.roleDisplayName !== "User") &&
          <Route path='/tags-directory' element={<TagDirectory />}></Route>
        }
        {(isAuthenticated && userData?.roleDisplayName !== "User") &&
          <Route>
            <Route path='/media-list' element={<VideoList />}></Route>
          </Route>
        }
        {(isAuthenticated && userData?.roleDisplayName === "Super_admin") &&
          <Route>
            <Route path='/superAdmin-list' element={<SuperAdminList />}></Route>
            <Route path='/admin-list' element={<AdminList />}></Route>
            <Route path='/approver-list' element={<ApproverList />}></Route>
            <Route path='/reprocess' element={<Reprocess />}></Route>
          </Route>
        }
        {(isAuthenticated && (userData?.roleDisplayName === "Super_admin" )) &&
          <Route>
            <Route path='/user-list' element={<UserList />}></Route>
            <Route path='/media-requests' element={<VideoRequest />}></Route>
          </Route>
        }
        {(isAuthenticated && (userData?.roleDisplayName === "APPROVER" ))&&
          <Route>
          <Route path='/media-requests' element={<VideoRequest />}></Route>
        </Route>
        }
        {(isAuthenticated && userData?.roleDisplayName === "User") &&
          <Route path='/my-requests' element={<MyRequests />}></Route>
        }
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
